<section class="platform-businesses-banner">
  <h1 class="visuallyhidden">{{ 'PLATFORM_BUSINESSES.INTRO_BANNER.HEADING' | translate }}</h1>
  <div class="box">
    <picture class="desktop">
      <source
        srcset="
          https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Main_page_Introduction_banner_Desktop.webp
        "
        type="image/webp"
      />
      <img
        src="https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Main_page_Introduction_banner_Desktop.jpg"
        alt="{{ 'PLATFORM_BUSINESSES.INTRO_BANNER.ALTTEXT' | translate }}"
        loading="eager"
        class="box-img"
      />
    </picture>
    <picture class="mobile">
      <source
        src="https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Main_page_Introduction_banner_Mobile.webp"
        type="image/webp"
      />
      <img
        src="https://flowaccountcdn.com/new_landing/image/platform-businesses/become-our-partner/Main_page_Introduction_banner_Mobile.jpg"
        alt="{{ 'PLATFORM_BUSINESSES.INTRO_BANNER.ALTTEXT' | translate }}"
        loading="eager"
        class="box-img"
      />
    </picture>
  </div>
</section>
